(function () {
  'use strict';

  /* Idempotent: bei versehentlich doppeltem Einbinden nicht erneut initialisieren. */
  if (window.RosentalKlaviyoBlocker) return;

  var BLOCKER_ID = 'klaviyo-popup-blocker';
  var BLOCKER_CSS =
    'div[aria-label="POPUP Form"],' +
    'div[role="dialog"][aria-label*="POPUP" i],' +
    'div[role="dialog"][aria-label*="Newsletter" i],' +
    '.klaviyo-form-version-cid_1,' +
    '.klaviyo-form,' +
    '.needsclick.kl-private-reset-css-Xuajs1{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important}' +
    'div[aria-label="POPUP Form"]{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important}';

  
  
  
  var SUPPRESSOR_SELECTORS = [
    
    'dialog[open]',
    'cart-drawer[open]',
    'menu-drawer[open]',
    'quick-add-drawer[open]',
    'native-drawer[open]',
    
    'body.no-scroll',
    'body.scroll-locked',
    'html.no-scroll',
    'html.scroll-locked',
    'body[data-drawer-open]',
    
    
    'csm-cookie-consent',
    '#consentmo-cookies-modal',
    '#consentmo_widget',
    '.cm-cookies-modal',
    '.cmp-c-window',
    '.consentmo-c-window',
    '[data-cookie-consent]',
    '#shopify-pc__banner',
    
    '.atc-success-modal[open]',
    '#search-drawer[open]'
  ];

  
  
  function shadowHasVisibleContent(root) {
    if (!root) return false;
    var children = root.children;
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      if (child.tagName === 'STYLE' || child.tagName === 'SCRIPT' || child.tagName === 'TEMPLATE') continue;
      var cs = window.getComputedStyle(child);
      if (!cs || cs.display === 'none' || cs.visibility === 'hidden') continue;
      var rect = child.getBoundingClientRect();
      if (rect.width > 50 && rect.height > 20) return true;
      
      if (child.children && child.children.length) {
        var grand = child.querySelectorAll('*');
        for (var j = 0; j < grand.length; j++) {
          var gs = window.getComputedStyle(grand[j]);
          if (!gs || gs.display === 'none' || gs.visibility === 'hidden') continue;
          var gr = grand[j].getBoundingClientRect();
          if (gr.width > 50 && gr.height > 20) return true;
        }
      }
    }
    return false;
  }

  function isElementVisible(el) {
    if (!el || !el.isConnected) return false;
    var style = window.getComputedStyle(el);
    if (!style) return false;
    if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) === 0) {
      return false;
    }
    if (el.hasAttribute('hidden')) return false;
    if (el.getAttribute('aria-hidden') === 'true') return false;

    /* Shadow hosts (e.g. csm-cookie-consent) keep a full-viewport,
       pointer-events:none host box even AFTER the banner was accepted —
       the host rect says nothing. Only the shadow content counts. */
    if (el.shadowRoot) {
      return shadowHasVisibleContent(el.shadowRoot);
    }

    var rect = el.getBoundingClientRect();
    if (rect.width > 0 && rect.height > 0) return true;

    return false;
  }

  function anySuppressorOpen() {
    for (var i = 0; i < SUPPRESSOR_SELECTORS.length; i++) {
      try {
        var els = document.querySelectorAll(SUPPRESSOR_SELECTORS[i]);
        for (var j = 0; j < els.length; j++) {
          if (isElementVisible(els[j])) return true;
        }
      } catch (_) {}
    }
    return false;
  }

  function installBlocker() {
    if (document.getElementById(BLOCKER_ID)) return;
    try {
      var style = document.createElement('style');
      style.id = BLOCKER_ID;
      style.textContent = BLOCKER_CSS;
      document.head.appendChild(style);
    } catch (_) {}
  }

  function removeBlocker() {
    var el = document.getElementById(BLOCKER_ID);
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  /* Klaviyo adds "klaviyo-prevent-body-scrolling" (body overflow:hidden)
     when it opens a popup. When the popup is suppressed (e.g. by our
     blocker while the cookie banner is open) or fails to render, Klaviyo
     never cleans the class up and the page stays unscrollable (P1 on NL,
     Sep 2026). Watchdog: if the class sits on <body> for >2s without any
     visible Klaviyo form, remove it. Grace period covers fade-in
     animations (forms start at opacity 0). */
  var SCROLL_LOCK_CLASS = 'klaviyo-prevent-body-scrolling';
  var orphanLockSince = 0;
  function anyVisibleKlaviyoForm() {
    var nodes = document.querySelectorAll('form.klaviyo-form, div[aria-label="POPUP Form"], div[role="dialog"][class*="kl-private"]');
    for (var i = 0; i < nodes.length; i++) {
      if (isElementVisible(nodes[i])) return true;
    }
    return false;
  }
  function fixOrphanScrollLock() {
    try {
      if (!document.body || !document.body.classList.contains(SCROLL_LOCK_CLASS)) {
        orphanLockSince = 0;
        return;
      }
      if (anyVisibleKlaviyoForm()) {
        orphanLockSince = 0;
        return;
      }
      var now = Date.now();
      if (!orphanLockSince) {
        orphanLockSince = now;
        setTimeout(evaluate, 2100);
        return;
      }
      if (now - orphanLockSince > 2000) {
        document.body.classList.remove(SCROLL_LOCK_CLASS);
        orphanLockSince = 0;
      }
    } catch (_) {}
  }

  var rafScheduled = false;
  function evaluate() {
    if (rafScheduled) return;
    rafScheduled = true;
    requestAnimationFrame(function () {
      rafScheduled = false;
      if (anySuppressorOpen()) installBlocker();
      else removeBlocker();
      fixOrphanScrollLock();
    });
  }

  
  
  
  var observer = new MutationObserver(evaluate);
  function startObserver() {
    try {
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['open', 'class', 'style', 'aria-hidden', 'hidden', 'data-drawer-open'],
        subtree: true,
        childList: true
      });
    } catch (_) {}
  }

  
  document.addEventListener('native-drawer:opened', evaluate, true);
  document.addEventListener('native-drawer:closed', evaluate, true);
  document.addEventListener('cart:open', evaluate, true);
  document.addEventListener('cart:close', evaluate, true);
  document.addEventListener('cart-drawer:prewarm', evaluate, true);

  /* Page-level exclusion (search, cart, account, policies, legal/service,
     sign-up pages, Membershop — see snippets/popup-standard-exclusions.liquid).
     snippets/js-variables.liquid sets window.__rosPopupsExcluded and an
     inline <style> that hides body-level Klaviyo dialogs before they paint;
     this closes whatever still opens (flyouts etc.) and frees Klaviyo's
     scroll lock. Embedded forms ('embedOpen') are never touched. */
  if (window.__rosPopupsExcluded) {
    window.addEventListener('klaviyoForms', function (e) {
      var d = e && e.detail;
      if (!d || d.type !== 'open' || !d.formId) return;
      try {
        var form = document.querySelector('[data-testid="klaviyo-form-' + d.formId + '"]');
        var wrap = form && form.closest('body > div');
        if (wrap && !wrap.className) {
          wrap.style.setProperty('display', 'none', 'important');
          wrap.setAttribute('data-ros-popup-excluded', '');
        }
        /* Klaviyo adds the scroll-lock class around (sometimes after) the
           'open' event — strip it now and again shortly afterwards. */
        [0, 150, 600, 1500, 3000].forEach(function (ms) {
          setTimeout(function () {
            if (document.body) document.body.classList.remove(SCROLL_LOCK_CLASS);
          }, ms);
        });
      } catch (_) {}
    });
  }

  window.RosentalKlaviyoBlocker = {
    block: installBlocker,
    unblock: removeBlocker,
    evaluate: evaluate,
    isBlocking: function () { return !!document.getElementById(BLOCKER_ID); },
    addSelector: function (sel) {
      if (typeof sel === 'string' && SUPPRESSOR_SELECTORS.indexOf(sel) === -1) {
        SUPPRESSOR_SELECTORS.push(sel);
        evaluate();
      }
    }
  };

  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      startObserver();
      evaluate();
    });
  } else {
    startObserver();
    evaluate();
  }
})();
